import { FabrixExternalLink, FabrixExternalLinkService} from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";


export interface FabrixExternalLinkOptions extends ControllerOptions<FabrixExternalLink> {
   
}

export const initializeFabrixExternalLink = () => {
    let tr: FabrixExternalLink = {
        name: "",
        url: ""
    }
    return tr;
}


export class ClientExternalLinkService extends BaseClientService implements DataController<FabrixExternalLink> {

    private _service: FabrixExternalLinkService;

    constructor() {
        super()
        this._service = new FabrixExternalLinkService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }
  

    public async get(options: FabrixExternalLinkOptions) {
        let fetchParams = this.buildFetchParams(options)
        return await this._service.get(fetchParams, this.token, options.filter);
    }

    public async getLookup(options: FabrixExternalLinkOptions) {
        let fetchParams = this.buildLookupFetchParams(options)
        return await this._service.get(fetchParams, this.token, options.filter);
    }

    public async getById(options: FabrixExternalLinkOptions) {
        if (options.id)
            return await this._service.getById(options.id, this.token);
        return null
    }


    public async add(options: FabrixExternalLinkOptions) {
        if (options.item)
            return await this._service.add(options.item, this.token);
        return null;
    }

    public async update(options: FabrixExternalLinkOptions) {
        if (options.item)
            return await this._service.update(options.item, this.token);
        return null;
    }


    public async delete(options: FabrixExternalLinkOptions) {
        if (options.id)
            return await this._service.delete(options.id, this.token);
    }

   public async import(options: FabrixExternalLinkOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: FabrixExternalLinkOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

}



interface SerializedBuffer {
    data?: number[];
}

export const getImageMimeType = (image: Buffer): string | undefined => {
    if (image.subarray(0, 4).equals(Buffer.from([0x89, 0x50, 0x4e, 0x47]))) return "image/png";
    if (image.subarray(0, 3).equals(Buffer.from([0xff, 0xd8, 0xff]))) return "image/jpeg";
    if (image.subarray(0, 4).toString("ascii") === "GIF8") return "image/gif";
    if (image.subarray(0, 2).toString("ascii") === "BM") return "image/bmp";
    if (image.subarray(0, 4).equals(Buffer.from([0x00, 0x00, 0x01, 0x00]))) return "image/x-icon";
    if (image.subarray(0, 4).toString("ascii") === "RIFF" && image.subarray(8, 12).toString("ascii") === "WEBP") return "image/webp";
    if (/^(<\?xml[^>]*>\s*)?<svg\b/i.test(image.subarray(0, 256).toString("utf8").trimStart())) return "image/svg+xml";
    return undefined;
}

export const getImageSource = (rowData: FabrixExternalLink): string | undefined => {
    if (!rowData.imageBase64 || !rowData.imageMimeType) return undefined;

    let imageBase64 = rowData.imageBase64;
    let imageMimeType = rowData.imageMimeType;

    // Existing records may contain a JSON-serialized Buffer inside the bytea column.
    if (imageMimeType === "application/octet-stream") {
        try {
            const serializedImage = JSON.parse(Buffer.from(imageBase64, "base64").toString("utf8")) as SerializedBuffer;
            if (Array.isArray(serializedImage.data)) {
                const image = Buffer.from(serializedImage.data);
                const detectedMimeType = getImageMimeType(image);
                if (detectedMimeType) {
                    imageBase64 = image.toString("base64");
                    imageMimeType = detectedMimeType;
                }
            }
        } catch {
            return undefined;
        }
    }

    return `data:${imageMimeType};base64,${imageBase64}`;
}